"use client";

import { useClientConfigProvider } from "@/app/config/client-config-provider";

export default function SpinnerLoaderV2() {
  const { getImagePath } = useClientConfigProvider();
  return (
    <div
      className="spinner-small-v2"
      style={{
        background: `url(${getImagePath("progress-c-icon.png")}) no-repeat`,
        backgroundSize: "contain",
      }}
    />
  );
}
